import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NameAndCode } from '@models/name-code-model';

@Component({
  selector: 'app-name-code-edit-modal',
  templateUrl: './name-code-edit-modal.component.html',
  styleUrls: ['./name-code-edit-modal.component.css'],
})
export class NameCodeEditModalComponent {
  constructor(
    public dialogRef: MatDialogRef<NameCodeEditModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { title: string; object: NameAndCode },
  ) {}

  save() {
    this.dialogRef.close(this.data.object);
  }
}
